import { useNavigate } from "react-router-dom";
import { SITE } from "@/lib/site";
import { useSiteImages } from "@/context/SiteImagesContext";

export const Logo = ({ size = "md", className = "", ...props }) => {
  const navigate = useNavigate();
  const { src } = useSiteImages();
  const h = size === "lg" ? "h-14 sm:h-16" : size === "sm" ? "h-8" : "h-10 sm:h-11";
  return (
    <span className={`inline-flex items-center ${className}`} {...props}>
      <img
        src={src("logo_wordmark")}
        alt={`${SITE.name} logo`}
        className={`${h} w-auto max-w-[220px] sm:max-w-[260px] object-contain select-none drop-shadow-[0_0_18px_rgba(99,102,241,0.35)]`}
        decoding="async"
        draggable={false}
        onDoubleClick={(e) => { e.preventDefault(); e.stopPropagation(); navigate("/admin"); }}
        data-testid="logo-image"
      />
    </span>
  );
};

export const LogoMark = ({ className = "h-10 w-10", ...props }) => {
  const { src } = useSiteImages();
  return <img src={src("logo_mark")} alt={`${SITE.name} mark`} className={`${className} rounded-2xl object-cover`} decoding="async" {...props} />;
};
